import React from "react";
import PropTypes from "prop-types";
import ClientContainer from "./ClientContainer";

function ColesseeContainerContent({ dialogState }) {
  return (
    <ClientContainer
      filterLens={dialogState.filterLens}
      isIndividualLens={dialogState.isIndividualLens}
      partnerListLens={dialogState.partnerListLens}
      selectedClientLens={dialogState.selectedClientLens}
      resetFiltersLens={dialogState.resetFiltersLens}
      resetSelectedClientLens={dialogState.resetSelectedClientLens}
      resetPartnerList={dialogState.resetPartnerList}
      validation={dialogState.validation}
      isReadOnly={false}
    />
  );
}

ColesseeContainerContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
};

export default ColesseeContainerContent;
